// @flow
import React, {PureComponent, Fragment, type Node} from 'react';
import Popover from 'react-tiny-popover';
import classNames from 'classnames';

import type {VoidFunctionType} from 'constants/flow/flowTypes';

import {disableScroll} from 'libs/disableScroll';
import {Z_INDEX} from 'constants/cssVariables';

import s from './popup.scss';

type PropsType = {
    visible: boolean,
    className: string,
    wrapClassName: string,
    children: Node,
    onClose: VoidFunctionType<SyntheticEvent<HTMLButtonElement>> | null,
    mask: boolean,
    maskStyle: {},
    title: Node,
    zIndex: number,
    closable: boolean,
    shouldScroll: boolean,
};

/**
 * Wrapper of RC popup
 */
export default class Popup extends PureComponent<PropsType> {
    static defaultProps = {
        className: '',
        wrapClassName: '',
        mask: true,
        maskStyle: {},
        zIndex: Z_INDEX['--zIndex-popup'],
        title: null,
        closable: true,
        onClose: () => {},
        shouldScroll: false,
    };

    /**
     * Called after component was updated.
     * @param {PropsType} prevProps - previous properties
     */
    componentDidUpdate(prevProps: PropsType) {
        if (
            document.body !== null &&
            prevProps.visible !== this.props.visible &&
            !this.props.shouldScroll
        ) {
            disableScroll(this.props.visible, true);
        }
    }

    /**
     * Render jsx to html
     * @returns {Node} Rendered react component
     */
    render(): Node {
        const {
            visible,
            zIndex,
            mask,
            wrapClassName,
            title,
            children,
            className,
            closable,
            onClose,
            maskStyle,
        } = this.props;
        return (
            <Popover
                isOpen={visible}
                transitionDuration={0.1}
                content={
                    <Fragment>
                        {mask && <div className={s.mask} style={maskStyle} />}
                        <div
                            tabIndex="-1"
                            role="dialog"
                            className={`${s.container} ${wrapClassName}`}
                            style={{zIndex}}
                        >
                            <div className={`${s.content} ${className}`}>
                                {closable && (
                                    <button
                                        aria-label="Close"
                                        className={classNames(s.close, 'gusa-popup-close-button')}
                                        onClick={onClose}
                                    />
                                )}
                                {title && <div className={s.header}>{title}</div>}
                                {children}
                            </div>
                        </div>
                    </Fragment>
                }
            >
                <span className={s.popupHiddenElement} />
            </Popover>
        );
    }
}
